<template>
  <div>
    <div class="ml-4 mr-4">
      <div
        class="is-flex is-justify-content-center"
        id="filtersContainer"
        v-click-outside="forceClose_closeDropdownBox"
      >
        <!--  TOGGLE MAP VIEW -->
        <ToggleMapViewForBookingResults :type="'hotel'" class="mr-1" />

        <!--  ALL FILTERS MODAL BOX -->
        <div ref="mainFilterButton" id="mainFilterButton">
          <ShowModalButton
            :rounded="true"
            :label="filterButtonLabel"
            :type="'is-info is-outlined'"
            :size="'is-small'"
            :icon-left="'filter-variant-plus'"
            :close-modal="closeCustomModal"
            :key="forceKey"
            data-test="modal_filters_button"
          >
            <template #modalContent>
              <div id="modalFilters">
                <h2 class="is-size-4 gant-text has-text-centered">
                  {{ filterButtonLabel }}
                </h2>
                <div class="is-flex is-justify-content-center pb-3">
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox();
                      $emit('clearFilters');
                      forceClose_closeModal();
                    "
                    class="ml-3"
                    :label="'Reset and Close'"
                  />
                </div>
                <hr class="mt-1 mb-5" />

                <div class="columns" style="padding:3%">
                  <!-- SORT BY -->
                  <div class="column is-flex">
                    <FieldsetBox
                      :box-style="value.sortOrder ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            value.sortOrder
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Sort by</span
                        >
                      </template>
                      <template #content>
                        <SortButtons
                          data-test="modal_sort_filter_list"
                          :value="value.sortOrder"
                          :options="sortOptions"
                          @input="handleSortInput"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- PRICE -->
                  <!--
                  <div class="column is-flex">
                    <FieldsetBox :box-style="highlights.price ? highlightedBoxStyle : ''">
                      <template #header>
                        <span class="textOnly" :class="highlights.price ? highlightedLabelClass : 'has-text-grey-light'">Price</span>
                      </template>
                      <template #content>
                        <b-field v-if="priceRange.length"
                                 :label="'Price: $'+ value.maxPrice[0] + '-$' + value.maxPrice[1]"
                                 style="width: 180px">
                          <HistogramSliderW2 v-model="priceRange" :width="180" :expo="true" :height="25" :sliderData="sliderData" @input="priceFilterUpdate"></HistogramSliderW2>
                        </b-field>
                      </template>
                    </FieldsetBox>
                  </div>
                  -->
                  <!-- POLICY -->
                  <div class="column is-flex">
                    <FieldsetBox
                      :box-style="value.minPolicy ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            value.minPolicy
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Policy</span
                        >
                      </template>
                      <template #content>
                        <PolicySelectionCheckboxes
                          data-test="modal_policy_filter_list"
                          :value="value.minPolicy"
                          :availablePolicies="availablePolicies"
                          @input="handlePolicyInput"
                        ></PolicySelectionCheckboxes>
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- AMENITIES -->
                  <div class="column is-flex">
                    <FieldsetBox
                      :box-style="highlights.price ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            highlights.amenities
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Amenities</span
                        >
                      </template>
                      <template #content>
                        <SelectionWithQuantityDisplay
                          data-test="modal_amenities_filter_list"
                          v-model="value.selectedAmenities"
                          :selectedItems="value.selectedAmenities"
                          :items="fullAmenities"
                          :filteredItems="filteredAmenities"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- CHAINS -->
                  <div class="column is-flex">
                    <FieldsetBox
                      :box-style="highlights.price ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            highlights.chains
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Hotel Chains</span
                        >
                      </template>
                      <template #content>
                        <ChainSelection
                          data-test="modal_chains_filter_list"
                          :preferredVendors="preferredVendors"
                          :preferredOnly.sync="preferredOnly"
                          :selectedChains="value.selectedChains"
                          :availableChains="availableChains"
                          :filteredChains="filteredChains"
                          :vendorsList="availableChains"
                          :availableBrands="availableBrands"
                          :selectedBrands="value.selectedBrands"
                          @input="handleChainInput"
                          @brandInput="handleBrandInput"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                </div>

                <div class="is-flex is-justify-content-center pt-5">
                  <b-button
                    type="is-primary"
                    size="is-small"
                    label="Apply Filters"
                    @click="forceClose_closeModal"
                    class="mr-1"
                  >
                  </b-button>
                  <b-button
                    type="is-outlined"
                    size="is-small"
                    label="Close"
                    @click="forceClose_closeModal"
                    class="mr-1"
                  >
                  </b-button>
                </div>
                <div class="is-flex is-justify-content-center pb-3">
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox();
                      $emit('clearFilters');
                    "
                  />
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox();
                      $emit('clearFilters');
                      forceClose_closeModal();
                    "
                    class="ml-3"
                    :label="'Reset and Close'"
                  />
                </div>
              </div>
            </template>
          </ShowModalButton>
        </div>

        <!--  THE REST of the FILTERS (Custom Dropdowns) -->
        <div
          ref="flexedFilters"
          id="flexedFilters"
          class="sortingFiltersContainer scrollContent is-flex is-hidden-mobile"
        >
          <!-- SORT BY -->
          <section data-test="sort_filter_section">
            <div ref="sortOrder">
              <b-button
                rounded
                data-test="sort_filter_button"
                size="is-small"
                :icon-right="!value.sortOrder ? 'menu-down' : null"
                :type="value.sortOrder ? 'is-info is-light' : 'is-outlined'"
                @click="
                  $popper.togglePopper($refs.sortOrder, $refs.sortButtons)
                "
              >
                Sort by{{ value.sortOrder ? ":" : "" }}
                <span class="has-text-weight-bold">{{ value.sortOrder }}</span>
                <ResetFilterButton
                  v-if="value.sortOrder"
                  @reset="resetFilter('sortOrder')"
                />
              </b-button>
            </div>
            <div ref="sortButtons" class="popper-popup filterBox">
              <FilterBoxHeader
                filter-name="Sort by"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <SortButtons
                data-test="sort_filter_list"
                :value="value.sortOrder"
                :options="sortOptions"
                @input="handleSortInput"
              />
            </div>
          </section>
          <!-- PRICE -->
          <!--
          <section>
            <div ref="maxPrice">
              <b-button
                  rounded
                  size="is-small"
                  :icon-right="!highlights.price ? 'menu-down' : null"
                  :type="highlights.price ? 'is-info is-light' : 'is-outlined'"
                  @click="$popper.togglePopper($refs.maxPrice, $refs.priceCBs)"
              >
                Price{{ highlights.price ? ':' : '' }} <span class="has-text-weight-bold" v-if="highlights.price">{{ `$${value.maxPrice[0]} - $${value.maxPrice[1]}` }}</span>
                <ResetFilterButton v-if="highlights.price" @reset="resetFilter('maxPrice')" />
              </b-button>
            </div>
            <div ref="priceCBs" class="filterBox popper-popup">
              <FilterBoxHeader filter-name="Max Price" @closeFilterBox="forceClose_closeDropdownBox"/>
              <div class="ml-3 mr-3">
                <b-field v-if="priceRange.length" :label="'Price:          $'+ value.maxPrice[0] + '-$' + value.maxPrice[1]" style="width: 180px">
                  <HistogramSliderW2 v-model="priceRange" :expo="true" :sliderData="sliderData" @input="priceFilterUpdate" :width="180" :height="25"></HistogramSliderW2>
                </b-field>
              </div>
            </div>
          </section>
          -->
          <!-- POLICY -->
          <section data-test="policy_filter_section">
            <div ref="minPolicy">
              <b-button
                rounded
                data-test="policy_filter_button"
                size="is-small"
                :icon-right="!value.minPolicy ? 'menu-down' : null"
                :type="value.minPolicy ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.minPolicy, $refs.policyCBs)"
                class="ml-0 mr-2 mb-2"
              >
                Policy{{ value.minPolicy ? ":" : "" }}
                <span class="has-text-weight-bold">{{
                  returnPolicyValues(value.minPolicy)
                }}</span>
                <ResetFilterButton
                  v-if="value.minPolicy"
                  @reset="resetFilter('minPolicy')"
                />
              </b-button>
            </div>
            <div ref="policyCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Min Policy"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <PolicySelectionCheckboxes
                data-test="policy_filter_list"
                :value="value.minPolicy"
                :availablePolicies="availablePolicies"
                @input="handlePolicyInput"
              />
            </div>
          </section>
          <!-- AMENITIES -->
          <section data-test="amenities_filter_section">
            <div ref="hotelAmenitiesButton">
              <b-button
                data-test="amenities_filter_button"
                rounded
                size="is-small"
                :icon-right="
                  value.selectedAmenities.length === 0 ? 'menu-down' : null
                "
                :type="
                  value.selectedAmenities.length > 0
                    ? 'is-info is-light'
                    : 'is-outlined'
                "
                @click="
                  $popper.togglePopper(
                    $refs.hotelAmenitiesButton,
                    $refs.hotelAmenitiesContent
                  )
                "
              >
                Amenities{{ value.selectedAmenities.length > 0 ? ":" : "" }}
                <span class="has-text-weight-bold filter-content-max-width">{{
                  value.selectedAmenities.map((amenity) => amenity).join(", ")
                }}</span>
                <ResetFilterButton
                  v-if="value.selectedAmenities.length > 0"
                  @reset="resetFilter('selectedAmenities')"
                />
              </b-button>
            </div>
            <div ref="hotelAmenitiesContent" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Amenities"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <SelectionWithQuantityDisplay
                data-test="amenities_filter_list"
                v-model="value.selectedAmenities"
                :items="fullAmenities"
                :filteredItems="filteredAmenities"
              />
            </div>
          </section>
          <!-- HOTEL CHAINS -->
          <section data-test="chains_filter_section">
            <div ref="hotelChainsButton">
              <b-button
                data-test="chains_filter_button"
                class="chains-filter"
                rounded
                size="is-small"
                :icon-right="
                  value.selectedChains.length === 0 ? 'menu-down' : null
                "
                :type="
                  value.selectedChains.length > 0
                    ? 'is-info is-light'
                    : 'is-outlined'
                "
                @click="
                  $popper.togglePopper(
                    $refs.hotelChainsButton,
                    $refs.hotelChainsContent
                  )
                "
              >
                Hotel Chains{{ value.selectedChains.length > 0 ? ":" : "" }}
                <span class="has-text-weight-bold filter-content-max-width">{{
                  value.selectedChains.map((chain) => chain.name).join(", ")
                }}</span>
                <ResetFilterButton
                  v-if="value.selectedChains.length > 0"
                  @reset="resetFilter('selectedChains')"
                />
              </b-button>
            </div>
            <div ref="hotelChainsContent" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Hotel Chains"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <ChainSelection
                data-test="chains_filter_list"
                :preferredVendors="preferredVendors"
                :preferredOnly.sync="preferredOnly"
                :selectedChains="value.selectedChains"
                :availableChains="availableChains"
                :filteredChains="filteredChains"
                :vendorsList="availableChains"
                :availableBrands="availableBrands"
                :selectedBrands="value.selectedBrands"
                @input="handleChainInput"
                @brandInput="handleBrandInput"
              />
            </div>
          </section>

          <ResetAllFiltersButton
            class="ml-5"
            @clicked="$emit('clearFilters')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SortButtons from "./SortButtons";
//import HistogramSliderW2 from '../HistogramSlider/HistogramSliderW2.vue';
import PolicySelectionCheckboxes from "./PolicySelectionCheckboxes";
import SelectionWithQuantityDisplay from "./SelectionWithQuantityDisplay";
import ToggleMapViewForBookingResults from "../BookTravel/ToggleMapViewForBookingResults";
import bookingMixin from "../../mixins/bookingMixin";
import ChainSelection from "./ChainSelection.vue";
import ShowModalButton from "../UI/ShowModalButton";
import ResetFilterButton from "./ResetFilterButton";
import FieldsetBox from "../UI/FieldsetBox";
import ResetAllFiltersButton from "./ResetAllFiltersButton";
import FilterBoxHeader from "./FilterBoxHeader";

export default {
  name: "HotelFiltersDropdowns",
  mixins: [bookingMixin],
  components: {
    SortButtons,
    //HistogramSliderW2,
    PolicySelectionCheckboxes,
    SelectionWithQuantityDisplay,
    ChainSelection,
    ToggleMapViewForBookingResults,
    ResetAllFiltersButton,
    ShowModalButton,
    ResetFilterButton,
    FieldsetBox,
    FilterBoxHeader,
  },
  data() {
    return {
      highlightedFilters: this.highlights,
      preferredOnly: false,
    };
  },
  props: {
    availableChains: Array,
    filteredChains: Array,
    fullAmenities: Object,
    filteredAmenities: Object,
    preferredVendors: Array,
    value: Object,
    mapView: Boolean,
    priceRange: Array,
    sliderData: Array,
    availablePolicies: Object,
    highestRating: Number,
    highlights: Object,
    originalPriceRange: Array, 
    sortOptions: Array,
    availableBrands: Array
  },
  methods: {
    handleChainInput(val) {
      this.value.selectedChains = val;
      this.$emit("input", this.value);
    },
    handleBrandInput(val) {
      this.value.selectedBrands = val;
      this.$emit("iput", this.value);
    },
    handleSortInput(val) {
      this.value.sortOrder = val;
      this.$emit("input", this.value);
    },
    handlePolicyInput(val) {
      this.value.minPolicy = val;
      this.$emit("input", this.value);
    },
    handleRatingInput(val) {
      this.value.minRating = val;
      this.$emit("input", this.value);
    },
    priceFilterUpdate(val) {
      /*
        if (this.value.maxPrice[0] != val[0] || this.value.maxPrice[1] != val[1]){
          this.value.maxPrice = val
          this.$emit('input', this.value)
        }
        */
    },

    resetFilter(filterType) {
      this.filterTypeToReset = filterType;
      this.$emit("resetFilter", this.filterTypeToReset);
      this.forceKey_forceKeyChange();
      this.forceClose_closeDropdownBox();
    },
  },
  computed: {
    numOfFiltersUsed() {
      console.log("numOfFiltersUsed", this.highlights);
      let num = 0;
      for (let highlight in this.highlights) {
        if (this.highlights[highlight] === true) {
          num++;
        }
      }
      return num;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.dropdown + .dropdown {
  margin-left: 0 !important;
}
.field {
  min-width: 130px;
}
</style>
